export function formatINR(amount, opts = {}) {
  const n = Number(amount || 0);
  return n.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: opts.maxFraction ?? 2,
    maximumFractionDigits: opts.maxFraction ?? 2,
  });
}

export function formatNumberIN(amount) {
  const n = Number(amount || 0);
  return n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatDate(value) {
  if (!value) return "—";
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return value;
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return String(value);
  }
}

export const STATUS_TONE = (status = "") => {
  const s = status.toLowerCase();
  if (s.includes("fully paid"))
    return "bg-emerald-50 text-emerald-700 border-emerald-200";
  if (s.startsWith("paid"))
    return "bg-blue-50 text-blue-700 border-blue-200";
  if (s.includes("crossed") || s.includes("overdue"))
    return "bg-red-50 text-red-700 border-red-200";
  if (s.includes("pending") && s.includes("within"))
    return "bg-amber-50 text-amber-700 border-amber-200";
  if (s.includes("approved"))
    return "bg-emerald-50 text-emerald-700 border-emerald-200";
  return "bg-slate-100 text-slate-700 border-slate-200";
};
